/**
 * created by lei lei
 *活动通知公告
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import CustomTable, {TitleIcon} from "../components/customTable/CustomTable";
import {Button, Icon, Modal} from 'antd';
import *as actions from "../../actions/notice"
import * as utils from "../../utils";
import {Scrollbars} from "react-custom-scrollbars";
import EditNotice from './EditNotice'
import SpacerBlock from'../components/spacerBlock/SpacerBlock'
import {FILE_TYPE} from "../../constants";
import ChunkUpload from "../../components/upload/ChunkUpload";
import UploadWall from "../../components/upload/UploadWall";
const {confirm} = Modal;

class Notice extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.actions = actions;
        this.state = {
            start: 1,
            size: 10,
            status: '-1',
            dataSource: [],
            count: 0,
            detailVisible: false,
            detailUrl: '',
            currentItem: {},
            fileList: [],
            content: '',
            departs: {
                'all': '全部',
                'report': '记者',
                'depart': '二级部门',
                'd_': '指定部门',
                'u_': '指定个人',
            }
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        //console.log(this.props.isPms)
        this.getAllNotification();
    }

    getAllNotification() {
        if (this.props.isPms) {
            let body = {
                start: this.state.start,
                size: this.state.size,
                status: this.state.status
            };
            this.actions.getAllNotification(body, (data) => {
                if (data && data.data) {
                    this.setState({
                        dataSource: data.data,
                        count: data.count
                    });
                    setTimeout(() => {
                        this.scrollRef && this.scrollRef.scrollToTop();
                    });
                }
            })
        } else {
            let body = {
                start: this.state.start,
                size: this.state.size,
                isread: '-1'
            };
            this.actions.getNotificationReceiverByAccountAndStatus(body, (data) => {
                if (data && data.data) {
                    this.setState({
                        dataSource: data.data,
                        count: data.count
                    });
                    setTimeout(() => {
                        this.scrollRef && this.scrollRef.scrollToTop();
                    });
                }
            })
        }

    }

    render() {
        let newSecondSelectColor = this.props.config && this.props.config.getValueByKey ? this.props.config.getValueByKey("newSecondSelectColor", '#0050B3') : '#0050B3';
        let titleKeyList =
            [
                {
                    key: 'title',
                    titleName: <b style={{fontSize: 15, color: '#a4adc8'}}>标题</b>,
                    width: '40%',
                    align: 'left',
                    ellipsis: true,
                    render: (text, record, index) => {
                        return (<div style={{
                            fontSize: 15, color: '#2a3a6b', fontWeight: 'bold', width: '100%', overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        }}>
                            {record.title}
                        </div>)
                    }
                },
                {
                    key: 'publish',
                    titleName: <b style={{fontSize: 15, color: '#a4adc8'}}>发送者</b>,
                    width: 250,
                    align: 'center',
                    render: (text, record, index) => {
                        return (<div style={{fontSize: 15, color: '#2a3a6b', fontWeight: 'bold',display:"flex",justifyContent:"left",marginLeft:"40px"}}>
                                {record.publish ? <img style={{
                                    height: 36,
                                    width: 36,
                                    objectFit: 'cover',
                                    borderRadius: '50%',
                                    marginRight: 5
                                }}
                                                       src={record.publish && record.publish.photoUrl ? record.publish.photoUrl : (record.publish && record.publish.sex === 1 ? 'images/header_boys.png' : 'images/header_girls.png')}
                                                       alt=""/> : null} {record.publish ? record.publish.name : ''}
                            </div>

                        )
                    }
                },
                {
                    key: 'publishDate',
                    titleName: <b style={{fontSize: 15, color: '#a4adc8'}}>发布时间</b>,
                    width: 200,
                    align: 'center',
                    render: (text, record, index) => {
                        return (<div style={{color: '#8792b3', fontSize: 15, fontWeight: 'bold'}}>
                            {record.status === 1||record.status === 2?'':<Icon type="clock-circle" theme="filled"
                                      style={{color: '#8792b3'}}/>} {record.status === 1||record.status === 2?'':utils.formatDate(record.publishDate.time)}
                            </div>

                        )
                    }
                },
                {
                    key: 'age',
                    titleName: <b style={{fontSize: 15, color: '#a4adc8'}}>状态</b>,
                    width: '15%',
                    align: 'center',
                    render: (text, record, index) => {
                        let statusText = '';
                        if (record.status === 1) {
                            statusText = <div style={{
                                width: 80,
                                height: 30,
                                background: '#ebedfc',
                                color: '#5a63e6',
                                fontSize: 14,
                                lineHeight: '30px',
                                margin: '0 auto'
                            }}>暂存</div>;
                        } else if (record.status === 2) {
                            statusText = <div style={{
                                width: 80,
                                height: 30,
                                background: '#ffe9e9',
                                color: '#ff6868',
                                fontSize: 14,
                                lineHeight: '30px',
                                margin: '0 auto'
                            }}>撤回</div>;
                        } else if (record.status === 3) {
                            statusText = <div style={{
                                width: 80,
                                height: 30,
                                background: '#e6f8ef',
                                color: '#35ce84',
                                fontSize: 14,
                                lineHeight: '30px',
                                margin: '0 auto'
                            }}>已发布</div>
                        }
                        if (!this.props.isPms) {
                            if (record.isread === 0) {
                                statusText = <div style={{
                                    width: 80,
                                    height: 30,
                                    background: '#fff6e9',
                                    color: '#ffa82b',
                                    fontSize: 14,
                                    lineHeight: '30px',
                                    margin: '0 auto'
                                }}>未读</div>
                            } else if (record.isread === 1) {
                                statusText = <div style={{
                                    width: 80,
                                    height: 30,
                                    background: '#e6f8ef',
                                    color: '#35ce84',
                                    fontSize: 14,
                                    lineHeight: '30px',
                                    margin: '0 auto'
                                }}>已读</div>
                            }
                        }
                        return (<div style={{fontWeight: 'bold', textAlign: 'center'}}>
                                {statusText}
                            </div>

                        )
                    }
                },
                {
                    key: 'status',
                    titleName: <b style={{fontSize: 15, color: '#a4adc8'}}>操作</b>,
                    width: 280,
                    align: 'left',
                    render: (text, record, index) => {
                        if (this.props.isPms) {
                            if (record.status === 1 || record.status === 2) {
                                return (<div style={{display: 'flex', fontWeight: 'bold'}}>
                                        <div style={{
                                            fontSize: 15,
                                            color: '#576184',
                                            lineHeight: '47px',
                                            width: 31,
                                            cursor: 'pointer'
                                        }} onClick={() => {
                                            this.pmsLook(record)
                                        }}>查看
                                        </div>
                                        <div style={{
                                            fontSize: 15,
                                            color: '#576184',
                                            lineHeight: '47px',
                                            width: 31,
                                            marginLeft: 20,
                                            cursor: 'pointer'
                                        }} onClick={() => {
                                            this.editNotice(record)
                                        }}>编辑
                                        </div>
                                        <div style={{
                                            width: 31,
                                            fontSize: 15,
                                            color: '#576184',
                                            lineHeight: '47px',
                                            marginLeft: 20,
                                            cursor: 'pointer'
                                        }} onClick={() => {
                                            this.delete(record)
                                        }} type="danger">删除
                                        </div>
                                    </div>

                                )
                            } else if (record.status === 3) {
                                return (<div style={{display: 'flex', fontWeight: 'bold'}}>
                                        <div style={{
                                            fontSize: 15,
                                            color: '#576184',
                                            lineHeight: '47px',
                                            width: 31,
                                            cursor: 'pointer'
                                        }} onClick={() => {
                                            this.pmsLook(record)
                                        }}>查看
                                        </div>
                                        <div style={{
                                            fontSize: 15,
                                            color: '#576184',
                                            lineHeight: '47px',
                                            width: 31,
                                            cursor: 'pointer',
                                            marginLeft: 20
                                        }} onClick={() => {
                                            this.withdraw(record)
                                        }}>撤回
                                        </div>
                                    </div>

                                )
                            }
                        } else {
                            return (<div style={{fontWeight: 'bold'}}>
                                    <div style={{
                                        fontSize: 15,
                                        color: '#576184',
                                        lineHeight: '47px',
                                        width: 31,
                                        cursor: 'pointer'
                                    }} onClick={() => {
                                        this.contributeLook(record)
                                    }}>查看
                                    </div>
                                </div>

                            )
                        }

                    }
                },
            ];

        let height = window.innerHeight - 77 - 70 - 10;
//        console.log(this.props.isPms);

        return (
            <div style={{padding: 20}}>
                <div style={{color: newSecondSelectColor, fontSize: 18, paddingBottom: 20,fontWeight:'bold'}}>
                    通知
                </div>
                <div style={{height: this.props.isPms ? height : height - 10, background: 'white'}}>
                    {this.props.isPms ?
                        <Button style={{marginTop: 20, marginLeft: 20,  background: newSecondSelectColor,
                            borderColor: newSecondSelectColor}} onClick={() => this.addNotice()}
                                type="primary">新增通知</Button> : null}

                    <div style={{height: this.props.isPms ? height - 70 : height + 60}}>
                        <Scrollbars  ref={(scrollRef) => {
                            this.scrollRef = scrollRef
                        }}>
                            <CustomTable
                                dataSource={this.state.dataSource}
                                titleKeyList={titleKeyList}
                                //下面属性参考antd table  属性去使用对外暴露，会全部引用用antd 的属性。
                                pagination={{
                                    showQuickJumper: true,
                                    total: this.state.count,
                                    onChange: (page, pageSize) => {
                                        this.paginationChange(page, pageSize)
                                    }, onShowSizeChange: (page, pageSize) => {
                                        this.paginationChange(page, pageSize)
                                    },
                                    showTotal: total => `共 ${total} 条数据`,
                                    showSizeChanger: true,
                                    pageSizeOptions: ['10', '20', '30', '40'],
                                    position: 'bottom'//这个版本目前只支持上下，不支持bottomLeft
                                }}
                                onRow={(record, index) => {
                                    return {
                                        onClick: event => {
                                            // console.log('onclickItem', record, index)
                                        }, // 点击行
                                        onDoubleClick: event => {
                                        },
                                        onContextMenu: event => {
                                        },
                                        onMouseEnter: event => {
                                        }, // 鼠标移入行
                                        onMouseLeave: event => {
                                        },
                                    };
                                }}
                                locale={{emptyText: '暂无数据'}}

                            />
                        </Scrollbars>
                    </div>
                    <Modal
                        title={null}
                        visible={this.state.detailVisible}
                        onOk={() => {
                        }}
                        width={1000}
                        onCancel={() => {
                            this.setState({detailVisible: false})
                        }}
                        footer={null}
                    >

                        <div className={'notice'} style={{height: '70vh', background: '#ffffff'}}>
                            <Scrollbars ref={(scrollRef) => {
                                this.scrollRef = scrollRef
                            }}>
                                <div style={{
                                    fontSize: 24,
                                    fontWeight: 'bold',
                                    lineHeight: '35px'
                                }}>{this.state.currentItem.title}</div>
                                <div style={{fontSize: 15, color: '#999999', paddingTop: 20,paddingBottom:20}}>
                                    <span>发布人：&nbsp;{this.state.currentItem.publish?this.state.currentItem.publish.name:this.state.currentItem.publisher}&nbsp;&nbsp;</span><span>发布范围：&nbsp;{this.state.departs[this.state.currentItem.chooseType]}&nbsp;&nbsp;</span><span>发布时间：&nbsp;{this.state.currentItem.publishDate ? utils.formatDate(this.state.currentItem.publishDate.time) : ''}</span>
                                </div>
                                <SpacerBlock height={1}  />
                                <div style={{marginTop:20}} dangerouslySetInnerHTML={{__html:this.state.content}}></div>
                                <div style={{display: 'flex', paddingTop: 20}}>
                                    <div style={{display: 'flex', height: 32, lineHeight: '32px'}}>
                                        <div style={{width: 60,fontWeight:'bold'}}>公告附件</div>
                                    </div>
                                    <div style={{marginLeft: 20}}>
                                        {this.state.fileList.length>0?<UploadWall
                                            accept={"." + FILE_TYPE.join(",.")}
                                            multiple={true}
                                            action="/cm-sites-pms/index/uploadFile"
                                            listType="list"
                                            fileList={this.state.fileList}
                                            icons={["download"]}
                                            showUploadBtn={false}
                                            onChange={()=>{}}
                                            onRemove={()=>{}}
                                            onDownload={(file) => {
                                                if (file.path.indexOf("?") === -1) {
                                                    window.location.href = file.path + "?download=1";
                                                } else {
                                                    window.location.href = file.path + "&download=1";
                                                }
                                            }}
                                        />:null}

                                    </div>
                                    <style>
                                        {`
           .notice img{
           width:100%
           }
                             `}</style>
                                </div>
                            </Scrollbars>
                        </div>
                    </Modal>
                </div>
                {this.props.isPms ? <EditNotice newSecondSelectColor={newSecondSelectColor} ref={EditNotice => {
                    this.EditNotice = EditNotice
                }} callBack={() => {
                    this.state.start = 1;
                    this.getAllNotification();
                }}/> : null}

            </div>
        )
    }

    addNotice() {
        let parms = {isAdd: true};
        this.EditNotice.editShow(parms)
    }

    //页码发生改变的时候
    paginationChange(page, pageSize) {
        this.state.start = page;
        this.state.size = pageSize;
        this.getAllNotification();
    }

    //撤回
    withdraw(record) {
        let that = this;
        confirm({
            title: '信息',
            content: '确定要撤回吗？',
            onOk() {
                let formdata = new FormData();
                formdata.append("notificationid", record.id);
                that.actions.backNotificationById(formdata, (date) => {
                    that.state.start = 1;
                    that.getAllNotification();
                })
            },
            onCancel() {
            },
        });
    }

    //删除
    delete(record) {
        let that = this;
        confirm({
            title: '信息',
            content: '确定要删除吗？',
            onOk() {
                let formdata = new FormData();
                formdata.append("notificationid", record.id);
                that.actions.delNotificationById(formdata, (date) => {
                    that.state.start = 1;
                    that.getAllNotification();
                })
            },
            onCancel() {
            },
        });
    }

    editNotice(record) {
        let parms = {isAdd: false, ...record};
        this.EditNotice.editShow(parms)
    }

    //pms端查看
    pmsLook(record) {
        this.state.currentItem = record;
        this.review(record);
        this.setState({detailVisible: true});
    }

    //contribute端查看
    contributeLook(record) {
        let formdata = new FormData();
        formdata.append("notificationReceiverId", record.id);
        this.actions.viewNotification(formdata, (data) => {
            this.getAllNotification();
            if (data && data.id) {
                this.state.currentItem = record;
                record.id=data.id;
                record.publisher = data.publisher;
                record.chooseType = data.chooseType;
                this.review(record);
                this.setState({detailVisible: true});
            }
        })

    }


    review(parms) {
        let formdata = new FormData();
        formdata.append("notificationid", parms.id);
        let fileList = [];
        this.actions.getAttachmentFile(formdata, (data) => {
            if(data.length){
                data && data.map(item => {
                    fileList.push({
                        resourceId: item.resourceId,
                        uid: parseInt(item.id) * -1,
                        name: item.name,
                        status: 'done',
                        url: item.path,
                        path: item.path,
                    })
                });
            }
            this.setState({fileList: fileList})
        });
        let content='';
        this.actions.getNotificationById(formdata, (data) => {
            content=data.content ? data.content: '';
                this.setState({content: content})
        });

        setTimeout(() => {
            this.scrollRef && this.scrollRef.scrollToTop();
        });
    }

}


function mapStateToProps(state) {
    return {
        config: state.systemReducer.config
    }
}

export default connect(mapStateToProps)(Notice);